"use client";

import { type ReactNode, createContext, useRef, useContext } from "react";
import { useStore } from "zustand";

import {
  type FlightStore,
  createFlightStore,
} from "@/stores/flight-store/FlightStore";

export type FlightStoreApi = ReturnType<typeof createFlightStore>;

export const FlightStoreContext = createContext<FlightStoreApi | undefined>(
  undefined,
);

export interface FlightStoreProviderProps {
  children: ReactNode;
}

export const FlightStoreProvider = ({ children }: FlightStoreProviderProps) => {
  const storeRef = useRef<FlightStoreApi | null>(null);
  if (!storeRef.current) {
    storeRef.current = createFlightStore();
  }

  return (
    <FlightStoreContext.Provider value={storeRef.current}>
      {children}
    </FlightStoreContext.Provider>
  );
};

export const useFlightStore = <T,>(selector: (store: FlightStore) => T): T => {
  const flightStoreContext = useContext(FlightStoreContext);

  if (!flightStoreContext) {
    throw new Error("useFlightStore must be used within CounterStoreProvider");
  }

  return useStore(flightStoreContext, selector);
};
